import { Typography } from '@mui/material';
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ActivityRecordingContext } from '../ActivityRecordingProvider';
import EventMarker from './EventMarker';

const EventMarkers = () => {
    const { t } = useTranslation();
    const { noteEvents, videoRecordingStartDate, videoDuration, skipToEvent } = useContext(ActivityRecordingContext);

    if (!videoRecordingStartDate || !videoDuration) {
        return null;
    }

    const renderEventMarkers = () => (
        noteEvents.map(e => (
            <EventMarker
                key={e.id}
                event={e}
                visicamStartDate={videoRecordingStartDate}
                videoDuration={videoDuration}
                onClick={() => skipToEvent(e.id)}
            />
        ))
    );

    const noEventsPlaceholder = () => {
        if (noteEvents.length === 0) {
            return <Typography variant="overline">{ t('activityRecordingViewer.text.noEventsPlaceholder')}</Typography>;
        } else {
            return null;
        }
    };

    return (
        <React.Fragment>
            { noEventsPlaceholder() || renderEventMarkers() }
        </React.Fragment>
    );
};

export default EventMarkers;
